import React from "react";
import { useParams } from "react-router-dom";
import { CONFIGURATIONS_NAV } from "src/config/configurationsNav";

export default function DummyConfigPage() {
  const { tab } = useParams();

  // Find the label from CONFIGURATIONS_NAV based on the current tab param
  let label = "Configuration Settings";
  for (const section of CONFIGURATIONS_NAV) {
    const item = section.items.find((i) => i.href.endsWith(`/${tab}`));
    if (item) {
      label = item.label;
      break;
    }
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold tracking-tight text-slate-900">{label}</h2>
        <p className="text-sm text-slate-500">
          Configure your organization settings for {label.toLowerCase()}.
        </p>
      </div>

      <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-200 bg-white py-16 text-center shadow-sm">
        <p className="text-sm font-medium text-slate-500">
          {label} settings are coming soon
        </p>
        <p className="mt-1 max-w-xs text-xs text-slate-400">
          This configuration interface is currently under development. Check back soon for updates!
        </p>
      </div>
    </div>
  );
}
